<template>
	<v-navigation-drawer
		id="app-drawer"
		v-model="inputValue"
		:src="image"
		app
		clipped
		dark
		:mini-variant="mini"
		mini-variant-width="64"
		mobile-breakpoint="991"
		width="260"
	>
		<v-layout class="fill-height">
			<v-list style="width: 100%;">
				<v-list-item class="logo-header">
					<v-list-item-title>{{userOrg}}</v-list-item-title>
				</v-list-item>
				<v-divider/>
				<v-list-item
					v-for="(link, i) in links"
					:key="'v-list-item' + i"
					:active-class="color"
					:disabled="disabledOptions[link.text]"
					:class="[{ mini: mini }, {'active-route': activeRoute(link.to)}]"
					@click="onClick(link.to)"
				>
					<v-list-item-action>
						<v-icon v-text="link.icon"></v-icon>
					</v-list-item-action>
					<v-list-item-title v-text="link.text"/>
				</v-list-item>

				<!-- menu icon for go portal -->
				<GoPortal />

				<!-- ready to go when we need an implementation but for now it's hidden 
					<ZeroLink />
				-->

			</v-list>
		</v-layout>
	</v-navigation-drawer>
</template>

<script>
	// Utilities
	import { mapMutations, mapState } from "vuex";
	import { GetUserByEmail } from "@/services/API.js";
	import GoPortal from "./GoPortal";
	//import ZeroLink from "./ZeroLink";

	// import { Logger } from "aws-amplify";
	// const logger = new Logger("Drawer");

	export default {
		components: {
			GoPortal,
			//ZeroLink
		},

		data: () => ({
			userOrg: '',
			links: [
				{
					to: "/dashboard",
					icon: "mdi-view-dashboard",
					text: "Organisations"
				},
				{
					to: "/jobs",
					icon: "mdi-clipboard-list",
					text: "Jobs"
				},
				{
					to: "/vehicles",
					icon: "mdi-car",
					text: "Vehicles"
				},
				{
					to: "/fleetstatus",
					icon: "mdi-car",
					text: "Fleet Status"
				},
				{
					to: "/device-management",
					icon: "mdi-settings",
					text: "Device Management"
				},
				{
					to: "/device-information",
					icon: "mdi-car-info",
					text: "Device Information"
				},
				{
					to: "/firmware",
					icon: "mdi-head-cog",
					text: "Firmware Management"
				},
				{
					to: "/log-files",
					icon: "mdi-file",
					text: "Device Logs"
				},
				{
					to: "/faults",
					icon: "mdi-alert",
					text: "Hardware Faults"
				},
				{
					to: "/user-activity",
					icon: "mdi-pulse",
					text: "User Activity"
				},
				{
					to: "/search-results",
					icon: "mdi-magnify",
					text: "Search Results"
				}
			],
			responsive: false,
			currentRoute: ''
		}),
		computed: {
			...mapState("app", ["image", "color", "mini"]),
			inputValue: {
				get() {
					return this.$store.state.app.drawer;
				},
				set(val) {
					this.setDrawer(val);
				}
			},
			disabledOptions () {
				const disabled = {
					"Jobs": !this.$can('listJobs'),
					"Vehicles": !this.$can('viewVehicle'),
					"Fleet Status": !this.$can('viewVehicle'),
					"Firmware Management": !this.$can('listFirmwarePackages'),
					"Organisations": !this.$can('listOrgs'),
					"User Activity": !this.$can('createUserActivityReport'),
					"Device Information": !this.$can('viewDeviceInfo')
				}
				return disabled
			}
		},
		watch: {
			$route() {
				this.setRoute();
			}
		},
		mounted() {
			this.setRoute();
			this.onResponsiveInverted();
			window.addEventListener("resize", this.onResponsiveInverted);
			this.getUserOrg();
		},
		beforeDestroy() {
			window.removeEventListener("resize", this.onResponsiveInverted);
		},
		methods: {
			...mapMutations("app", ["setDrawer", "toggleDrawer"]),
			onResponsiveInverted() {
				if (window.innerWidth < 991) {
					this.responsive = true;
				} else {
					this.responsive = false;
				}
			},
			setRoute() {
				this.currentRoute = this.$route.path;
			},
			activeRoute(route) {
				return this.currentRoute == route ? true : false;
			},
			onClick(to) {
				this.$router.push({ path: to });
			},
			async getUserOrg() {
				let email = this.$store.state.email;

				const user = await GetUserByEmail(email);

				if (user) {
					this.userOrg = user.Org.name;
				}
			}
		}
	};
</script>

<style lang="scss">
	#app-drawer {
		z-index: 6;
		&.v-navigation-drawer--mini-variant {
			.v-list-item {
				&:not(.logo-header) {
					margin: 10px 11px 0;
				}
			}
			.logo-header {
				width: 64px;
			}
		}
		.v-list-item {
			border-radius: 4px;

			&--buy {
				margin-top: auto;
				margin-bottom: 17px;
			}
		}

		.logo-header {
			padding: 0 12px;
			height: 64px;
		}

		.v-image__image--contain {
			top: 9px;
			height: 60%;
		}

		.search-input {
			margin-bottom: 30px !important;
			padding-left: 15px;
			padding-right: 15px;
		}

		.active-route {
			background-color: rgba(200, 200, 200, 0.2) !important;
		}
	}
</style>
